<template lang="pug">
  div
    v-row(no-gutters class="mb-6" align="center")
      Title(titleName="Комплексы")
      v-btn(color="#07f" dark, @click="addNewComplex")
        v-icon(small) add
        span Создать комплекс
    v-row
      v-col(cols="4", v-for="(item, index) in complexCompanyList", :key="index")
        v-card(class="complex-card", flat, @click="viewComplexPage(item.complexId)", :ripple="false")
          v-img(
            class="complex-card__image",
            height="180px"
            :src="item.photos[0] === undefined ? require('@/assets/images/noimage.png') : item.photos[0]")
          v-col
            v-row(no-gutters, justify="space-between", align="center")
              span(class="complex-card__date") {{ moment(item.creationDate).format('LL') }}
              div(v-if="userRole === 'Admin' || userRole === 'Company'")
                // v-btn(icon class="mr-1" color="primary" @click.stop="")
                  v-icon() edit
                v-btn(icon color="error", @click.stop="removeComplexById(item.complexId, item.companyId)")
                  v-icon() delete
            h3(class="complex-card__title") {{ item.name }}
            div(class="complex-card__description") {{ item.description }}
</template>

<script>
import { mapState } from 'vuex'
import Title from '../../components/Adverts/AddNew/Title'
export default {
  components: { Title },
  watch: {
    userRole: {
      immediate: true,
      handler(value) {
        if (value) {
          this.$store.dispatch('GET_COMPLEX_LIST', this.userCompany.companyId)
        }
      }
    }
  },
  computed: {
    ...mapState({
      userCompany: state => state.userCompany,
      complexCompanyList: state => state.complex.complexCompanyList,
      userRole: state => state.userInfo.role
    })
  },
  methods: {
    addNewComplex() {
      this.$router.push({ path: '/complex/item/add' })
    },
    viewComplexPage(id) {
      this.$store.dispatch('SET_VIEWED_COMPLEX', id)
      this.$router.push({ path: `/complex/${id}` })
    },
    removeComplexById(complexId, companyId) {
      this.$store
        .dispatch('REMOVE_COMPLEX_BY_ID', { complexId })
        .then(response => {
          if (response.success) {
            this.$store.dispatch('GET_COMPLEX_LIST', companyId)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.complex-card {
  border-radius: 6px;
  &__image {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  &__date {
    color: #456990;
    font-size: 10px;
    font-weight: 400;
    display: block;
  }
  &__title {
    color: #000;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.73 px;
    margin-bottom: 8px;
  }
  &__description {
    color: #8e8e93;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: -0.41 px;
    max-height: 48px;
    height: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  &:hover {
    cursor: pointer;
    box-shadow: 0 0 20px rgba(61, 90, 254, 0.4);
  }
  &__reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: 0.5;
    position: absolute;
    width: 100%;
    background: whitesmoke;
  }
}
</style>
